import { render, staticRenderFns } from "./storeTag.vue?vue&type=template&id=46380ec8&scoped=true"
import script from "./storeTag.vue?vue&type=script&lang=js"
export * from "./storeTag.vue?vue&type=script&lang=js"
import style0 from "./storeTag.vue?vue&type=style&index=0&id=46380ec8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46380ec8",
  null
  
)

export default component.exports